export default "__VITE_ASSET__dcf4721e__"